const zh = {
  login: '登录',
  account: '账号',
  connect: '连接钱包',
  send: '发送',
  sent: '已发送',
  tokenSymbol: '选择资产',
  nostrAssets: 'Nostr Assets 批量转帐工具',
  sending: '发送中',
  currentAddress: '当前地址',
  receiveAddresses: '接收地址',
  upgradeAndOpenSwitch: '您当前仍未启用Nostr，请升级到最新版本TokenPocket并启用Nostr后重试。 <a href="https://help.tokenpocket.pro/cn/wallet-operation/protocol/nostrassets" target="_blank"> 查看教程 </a>',
  upgradeAndOpenSwitchPC: '您当前仍未启用Nostr，请升级到最新版本TokenPocket并启用Nostr后重试。 <a href="https://help.tokenpocket.pro/cn/wallet-operation/protocol/nostr#ru-he-zai-tokenpocket-kai-qi-nostr-1" target="_blank"> 查看教程 </a>',
  amountPlaceHolder: '1000',
  addressInvalid: '接受地址格式不正确',
  addressPlaceHolder: '请输入以npub开头的nostr地址, 每行一条',
  sendingAmount: '分发给每个地址的数量',
  downloadTP: '请下载TokenPocket钱包使用: <a href="https://tokenpocket.pro/?from=insc" target="_blank">TokenPocket Wallet </a>'
};

export default zh;